import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

import { FormPanelMeta, PanelComponentBase } from '../panels.types';

@Component({
  selector: 'app-panel-related-table',
  templateUrl: './related-table.component.html',
  styleUrls: ['./related-table.component.scss'],
})
export class PanelTableComponent extends PanelComponentBase<FormPanelMeta> implements OnInit {
  title = new FormControl('');
  customObjectsOnly: boolean;

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
    this.ui = { ...this.ui, editMode: false };
    this.panelDefMemento = JSON.parse(JSON.stringify(this.panelDef));
  }

  cancelEdit(): void {
    this.ui = { ...this.ui, editMode: !this.ui.editMode };
    this.panelDef = JSON.parse(JSON.stringify(this.panelDefMemento));
    this.editToggled.emit({ toggle: false, panelDef: this.panelDef });
  }

  toggleEditMode(): void {
    this.ui = { ...this.ui, editMode: !this.ui.editMode };
    this.title.setValue(this.panelDef.title);
    this.editToggled.emit({ toggle: true, panelDef: this.panelDef });
    this.changeDetectorRef.detectChanges();
  }

  saveLayout(): void {
    this.panelDef = {
      ...this.panelDef,
      title: this.title.value,
      meta: { ...this.panelDef.meta, fields: this.panelDef.meta.fields.filter((row) => row.length) },
    };
    this.panelDefUpdated.emit(this.panelDef);
    this.panelDefMemento = JSON.parse(JSON.stringify(this.panelDef));
    this.ui = { ...this.ui, editMode: !this.ui.editMode };
    this.editToggled.emit({ toggle: false, panelDef: this.panelDef });
  }
}
